<template>
  <v-container class="rs-controls" fluid>
    <template v-if="bridge">
      <v-row dense>
        <v-col :cols="bridge.bootupStartTime && bridge.bootupTimeLeft > 0 ? 11 : 12">
          <v-row v-if="bridge.rpcVersionInfo">
            Regler-Version
            <ul>
              <li>Version: {{ bridge.rpcVersionInfo.rpcVersionString }}</li>
              <li>Changeset: 0x{{ bridge.rpcVersionInfo.changeset.toString(16) }}</li>
              <li>Customization-Id: {{ bridge.rpcVersionInfo.customizationId }}</li>
              <li>Applikations Id: {{ bridge.rpcVersionInfo.applicationSpecificId }}</li>
            </ul>
          </v-row>
          <v-row dense>
            <v-col cols="2">
              <OnionRpcMethodButton
                @sendRpcMessage="sendRpcMessage"
              />
            </v-col>
            <v-col cols="2">
              <TooltipBtn
                :block="true"
                btnText="Send Firmwareupdate"
                @click="simulateFirmwareUpdate"
              >
                Führt die Schritte eines Firmwareupdates durch
              </TooltipBtn>
            </v-col>
            <v-col cols="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <span
                    v-on="tooltip"
                  >
                  <v-checkbox
                    v-model="performCombiUpdate"
                    label="Kombiupdate"
                  ></v-checkbox>
                  </span>
                </template>
                Kombiupdate Simulieren inklusive Neustart des Onions
              </v-tooltip>
            </v-col>
            <v-col cols="2">
              <v-select
              v-model="onionResetVariant"
              label="Neustartbedingung"
              :items="onionResetVariants"
              return-object
              item-text="name"
              ></v-select>
            </v-col>
            <v-col cols="2">
              <v-btn
                @click="performOnionRestart"
              >
                Neustart
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-text-field
                v-model="onionResetTime"
                label="Neustartzeit (s)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="true && bridge">
              <OnionRpcMessageTable
                ref="onionRpcMessageTable"
              ></OnionRpcMessageTable>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="1"
          v-if="bridge.bootupStartTime && bridge.bootupTimeLeft > 0"
        >
          Hochfahrzeit verbleibend: {{ ( bridge.bootupTimeLeft ).toFixed(0) }} s
        </v-col>
      </v-row>
    </template>
    <v-row dense>
      <v-col>
        <v-checkbox
          v-model="powerValueActive"
          label="Leistungswert über Onion RPC"
        ></v-checkbox>
      </v-col>
    </v-row>
    <template v-if="bridge && powerValueActive">
      <v-row dense>
        <v-col cols="4" v-for="(button, index) in buttons" :key="`button-${index}`">
          <SensorButton
            :visible="powerValueActive"
            :ref="`onionrpc_btn_${index}`"
            v-model="button.value"
            :conversion="button.conversion"
            :name="button.name"
            :initialValue="button.initialValue"
            @input="onSensorInput(button, button.platformIndex == null ? index : button.platformIndex, $event)"
          />
        </v-col>
      </v-row>
      <v-row v-for="(consumer, i) in bridge.consumers" :key="i">
        <v-col cols="4">
          <v-text-field
            v-model="consumer.maximumPower"
            label="Leistung am Ausgang"
          >
            <template v-slot:append>W</template>
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-select
            label="Verbraucher"
            v-model="consumer.output"
            :items="controllerOutputs"
            return-object
            item-text="name"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="consumer.activePower"
            label="Verbrauchte Leistung"
            :disabled="true"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
/*
  Nutzung:

  in der Device-Simulation:
    Add simulationDevices:
      { id: 9, component: OnionRpc, deviceLabel: 'Onion Omega', deviceColor: 'deep-orange lighten-2', props: {
        onionBootupTime: 30000, // 30s
        onionRestartTime: 60000, // 60s
        controllerOutputs: [ // Set as avaiable in the controller. These outputs are for PowerSensor
          { name: 'R1', index: 2, },
          { name: 'R2', index: 3, },
          { name: 'R3', index: 4, },
          { name: 'R4', index: 5, },
          { name: 'R5', index: 6, },
          { name: 'A1', index: 7, },
          { name: 'A2', index: 8, },
        ],
      }},

    Add busConfigurations:
      {
        label: 'Omega', connections: [
          {
            id: 'Regler zu Onion',
            from: { deviceId: 0, uart: 3}, // Check controller device Id and UART Index
            to: { deviceId: 9, uart: 0},
            suppressEcho: true, // Nessesary for correct behaviour on controller side
          }
        ]
      },

    Add outputConfigurations:
      {
        id: 'Omega_GPIO15', // EventQueue
        from: { deviceId: 0, configId: 0x36740c2c, index: 15 }, // Check controllers configId
        to: { deviceId: 9, index: 0, outputType: 2 }
      }, {
        id: 'Omega_GPIO16', // BootupPin
        from: { deviceId: 9, index: 1},
        to: { deviceId: 0, configId: 0x36740c2c, index: 16 }, // Check controllers configId
      }, { // Use only for power consumer available controller outputs
        id: 'R1',
        from: { deviceId: 0, index: 0 },
        to: { deviceId: 1, index: 0 },
      }, {
        id: 'R2',
        from: { deviceId: 0, index: 1 },
        to: { deviceId: 1, index: 1 },
      }, {
        id: 'R3',
        from: { deviceId: 0, index: 2 },
        to: { deviceId: 1, index: 2 },
      }, {
        id: 'R4',
        from: { deviceId: 0, index: 3 },
        to: { deviceId: 1, index: 3 },
      }, {
        id: 'R5',
        from: { deviceId: 0, index: 4 },
        to: { deviceId: 1, index: 4 },
      }, {
        id: 'A1',
        from: { deviceId: 0, index: 5 },
        to: { deviceId: 1, index: 5 },
      }, {
        id: 'A2',
        from: { deviceId: 0, index: 6 },
        to: { deviceId: 1, index: 6 },
      }
*/
import { OnionBridge } from '@/bridges/OnionBridge.js';
import SensorButton from '@/components/SensorButton';
import TooltipBtn from '@/components/TooltipBtn.vue';
import OnionRpcMethodButton from '@/components/OnionRpc/OnionRpcMethodButton';
import OnionRpcMessageTable from '@/components/OnionRpc/OnionRpcMessageTable';

/*
  Property description:
    onionBootupTime           time between system start and onion device starts working (sending messages)
    onionRestartTime          time after pressing restart button (and device stop working) and restarting bootup time
    controllerOutputs         definition of controller outputs
    firmwareUpdateSimulation  configuration object for the firmware update simulation. Default:
      {
        storageIndex: 0, //default 0
        firmwareFileSize: 16380,
        pageSize: 4096, // default: 4096
        transimitByteLength: 512, // default 512, change to 64 if guru meditation occures
      },
*/
export default {
  props: [
    'onionBootupTime',
    'onionRestartTime',
    'controllerOutputs',
    'firmwareUpdateSimulation',
  ],

  components: {
    OnionRpcMethodButton,
    OnionRpcMessageTable,
    SensorButton,
    TooltipBtn,
  },

  data: () => ({
    bridge: null,
    intervalId: 0,
    powerValueActive: false,

    buttons: [
      { conversion: 'rawPower', value: null, initialValue: 0, name: 'Verfügbar' },
    ],

    uarts: [
      { name: 'UART0', kind: 'Uart', label: 'Controller<->Onion' },
    ],

    onionResetVariants: [
      { name: 'Neustart ohne Nachricht', value: 0 },
      { name: 'Neustart mit Nachricht', value: 1 },
      { name: 'Neustart für Update', value: 2 },
    ],
    onionResetVariant: null,
    onionResetTime: '10',
    performCombiUpdate: true,
  }),

  methods: {
    async prepareDevice() {
      this.bridge = new OnionBridge({
        onionBootupTime: this.onionBootupTime || 120000,
        onionRestartTime: this.onionRestartTime || 120000,
        firmwareUpdateSimulation: this.firmwareUpdateSimulation || {
          storageIndex: 0,
          firmwareFileSize: 16380,
          pageSize: 4096,
          transimitByteLength: 512,
        },
        buttons: this.buttons,
      });
      this.intervalId = setInterval(this.intervalHandler.bind(this), 1000);

      if (this.onionRestartTime != null) {
        this.onionResetTime = this.onionRestartTime  / 1000;
      }

      for (let i = 0; i < 5; i += 1) {
        this.bridge.consumers.push({
          maximumPower: 0,
          activePower: 0,
          output: null,
          type: 0,
          value: 0,
        });
      }

      this.bridge.on('message', this.newMessage.bind(this));
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    onSensorInput(/*button, index, value*/) {},

    intervalHandler() {
      this.bridge.intervalHandler();
    },

    sendRpcMessage(msg) {
      this.$nextTick(() => {
        this.bridge.channel.sendRpcMessage(msg.method, msg.params);
      });
    },

    getRestartOptions() {
      let reason = null;
      if (this.onionResetVariant != null) {
        if (this.onionResetVariant.value === 0) {
          // nop
        } else if (this.onionResetVariant.value === 1) {
          reason = 50; // PLATFORM_RESET_REASON_APPLICATION
        } else if (this.onionResetVariant.value === 2) {
          reason = 40; // PLATFORM_RESET_REASON_UPDATE_REQUEST
        }
      }
      let restartTimeMs = this.onionRestartTime;
      if (this.onionResetTime) {
        restartTimeMs = (+this.onionResetTime) * 1000;
      }
      return { reason, restartTimeMs };
    },

    performOnionRestart() {
      const options = this.getRestartOptions();
      this.bridge.performOnionRestart(options.reason, options.restartTimeMs);
    },

    simulateFirmwareUpdate() {
      const options = this.getRestartOptions();
      this.$nextTick(() => {
        this.bridge.simulateFirmwareUpdate(this.performCombiUpdate, options.restartTimeMs);
      });
    },

    newMessage(message) {
      if (this.$refs.onionRpcMessageTable) {
        this.$refs.onionRpcMessageTable.addMessage(message);
      }
    },
  },
};
</script>

<style>

</style>